import { useState } from 'react';
import { Alert, Box, Button, Paper, Stack, Typography } from '@mui/material';
import MarkEmailUnreadOutlinedIcon from '@mui/icons-material/MarkEmailUnreadOutlined';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import { isAxiosError } from 'axios';
import api from '../../../api/axiosInstance';
import { showError, showSuccess } from '../../../components/notifications';
import { useAuth } from '../../../provider/AuthProvider';

function NoApprovedEmail() {
  const [info, setInfo] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const { logout } = useAuth();

  const onClickSendConfirm = async () => {
    setLoading(true);

    try {
      const response = await api.get<{ message: string }>('/auth/resendconfirmation');
      const message = response.data.message;

      setInfo(message);
      showSuccess(message);
    } catch (err: unknown) {
      let message = 'Ошибка при отправке ссылки';

      if (isAxiosError(err)) {
        message = err.response?.data?.message ?? err.message;
      } else if (err instanceof Error) {
        message = err.message;
      }

      setInfo(message);
      showError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        py: 4,
        bgcolor: 'rgba(25, 118, 210, 0.03)',
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: '100%',
          maxWidth: 440,
          p: { xs: 2.5, sm: 3 },
          border: '1px solid rgba(0,0,0,0.08)',
          borderRadius: 2,
          boxShadow: '0 18px 45px rgba(15, 23, 42, 0.08)',
        }}
      >
        <Stack spacing={2.25} alignItems="center" textAlign="center">
          <Box component="img" src="/logo.png" alt="SaveToRich" sx={{ width: 140 }} />

          <Box
            sx={{
              width: 58,
              height: 58,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: 'rgba(25, 118, 210, 0.08)',
              color: 'primary.main',
            }}
          >
            <MarkEmailUnreadOutlinedIcon />
          </Box>

          <Box>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.75 }}>
              Подтвердите email
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Мы отправили письмо со ссылкой подтверждения. После перехода по ссылке обновите эту
              страницу.
            </Typography>
          </Box>

          {info && (
            <Alert severity="info" sx={{ width: '100%', textAlign: 'left' }}>
              {info}
            </Alert>
          )}

          <Stack spacing={1.25} sx={{ width: '100%' }}>
            {info ? (
              <Button
                variant="contained"
                fullWidth
                size="large"
                startIcon={<RefreshOutlinedIcon />}
                onClick={() => window.location.reload()}
              >
                Обновить страницу
              </Button>
            ) : (
              <Button
                variant="contained"
                fullWidth
                size="large"
                startIcon={<SendOutlinedIcon />}
                onClick={onClickSendConfirm}
                disabled={loading}
              >
                {loading ? 'Отправляем...' : 'Отправить ссылку еще раз'}
              </Button>
            )}

            <Button
              variant="text"
              fullWidth
              startIcon={<LogoutOutlinedIcon />}
              onClick={() => logout()}
              disabled={loading}
            >
              Выйти
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
}

export default NoApprovedEmail;
